import { selectLocale } from 'accessors'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import styles from './BillingTaxRateDialog.module.scss'

const BillingTaxDetailsDialog = ({ billingTaxRate, handleClose, handleConfirm }) => {
  const [rate, setRate] = useState(billingTaxRate)
  const [taxId, setTaxId] = useState('')

  function formatCAbusinessNumber(number) {
    var match = number.match(/(\d{9})(\s)?(\w{0,2})?(\d{0,4})?/)
    setTaxId(number)

    if (match) {
      setTaxId(
        match[1] +
          ((match[2] === undefined || match[2] === ' ') && match[3] ? ' ' : '') +
          (match[3]?.toUpperCase() || '') +
          (match[4] || '')
      )
    } else {
      setTaxId(number)
    }
  }

  function formatEIN(number) {
    var match = number.match(/(\d{2})(-)?(\d{1,7})?/)

    if (match) {
      setTaxId(match[1] + '-' + (match[3] ? match[3] : ''))
    } else {
      setTaxId(number)
    }
  }

  const locale = useSelector(selectLocale)

  return (
    <ConfirmationDialog
      title="Update billing tax rate"
      theme="blacklist"
      positiveMessage="Save changes"
      onClose={handleClose}
      onConfirm={() => handleConfirm({ billingTaxRate: rate, taxId })}
      isButtonDisabled={!(rate >= 0 && rate < 30)}
    >
      <div className={styles.container}>
        <TextInput
          label="Tax rate percentage"
          value={rate}
          type="number"
          step={0.1}
          max={30}
          min={0}
          onChange={e => setRate(Number(e.target.value))}
        />
        {locale === 'en-CA' ? (
          <TextInput
            label="Tax Id (Federal business number)"
            maxlength={16}
            minlength={16}
            placeholder="123456789 RT0001"
            value={taxId}
            required
            onChange={e => formatCAbusinessNumber(e.target.value)}
            className={styles.input}
          />
        ) : (
          <TextInput
            maxlength={9}
            minlength={9}
            label="Tax Id (Employer identification number)"
            placeholder="xx-xxxxxxx"
            value={taxId}
            required
            onChange={e => formatEIN(e.target.value)}
            className={styles.input}
          />
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default BillingTaxDetailsDialog
